import React from "react";
import Typography from "@mui/material/Typography";

const SingleValue = (props) => {
  return (
    <Typography
      sx={{
        fontSize: 16,
        width: "100%",
        ...props.getStyles("singleValue", props),
      }}
    >
      {props.children}
    </Typography>
  );
};

export default SingleValue;
